import apiClient from './client';
import { BackgroundJob, JobStatus, JobType } from '../types';

export interface JobListResponse {
  items: BackgroundJob[];
  total: number;
  limit: number;
  offset: number;
}

export interface ListJobsParams {
  status?: JobStatus;
  type?: JobType;
  client_id?: string;
  limit?: number;
  offset?: number;
}

export const jobsApi = {
  /**
   * List all jobs for the organization with optional filters
   */
  listJobs: async (params: ListJobsParams = {}): Promise<JobListResponse> => {
    const searchParams = new URLSearchParams();

    if (params.status) {
      searchParams.append('status', params.status);
    }
    if (params.type) {
      searchParams.append('type', params.type);
    }
    if (params.client_id) {
      searchParams.append('client_id', params.client_id);
    }
    if (params.limit !== undefined) {
      searchParams.append('limit', params.limit.toString());
    }
    if (params.offset !== undefined) {
      searchParams.append('offset', params.offset.toString());
    }

    const queryString = searchParams.toString();
    const url = queryString ? `/jobs?${queryString}` : '/jobs';

    const response = await apiClient.get<JobListResponse>(url);
    return response.data;
  },

  /**
   * Get a single job by ID
   */
  getJob: async (jobId: string): Promise<BackgroundJob> => {
    const response = await apiClient.get<BackgroundJob>(`/jobs/${jobId}`);
    return response.data;
  },
};
